import { render, staticRenderFns } from "./LiuexPrepositions.vue?vue&type=template&id=6aaef834&scoped=true&"
import script from "./LiuexPrepositions.vue?vue&type=script&lang=js&"
export * from "./LiuexPrepositions.vue?vue&type=script&lang=js&"
import style1 from "./LiuexPrepositions.vue?vue&type=style&index=1&id=6aaef834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaef834",
  null
  
)

export default component.exports